import { render } from "./document_approval.html?vue&type=template&id=65c8cc22&external"
import script from "./document_approval.js?vue&type=script&lang=js&external"
export * from "./document_approval.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__